// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"FullWidthImage_imageWrapper__lgA_5"};